import React from 'react';

export const MessageThird = ({
  width = '14',
  height = '14',
  fill = '#121212',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_11068)">
        <path
          d="M0.800781 11.2C0.800781 12.0824 1.51838 12.8 2.40078 12.8H5.26958L8.00078 15.5312L10.732 12.8H13.6008C14.4832 12.8 15.2008 12.0824 15.2008 11.2V1.6C15.2008 0.7176 14.4832 0 13.6008 0H2.40078C1.51838 0 0.800781 0.7176 0.800781 1.6V11.2ZM2.40078 1.6H13.6008V11.2H10.0696L8.00078 13.2688L5.93198 11.2H2.40078V1.6Z"
          fill={fill}
        />
        <path
          d="M7.20078 9.59995H8.80078V7.19995H11.2008V5.59995H8.80078V3.19995H7.20078V5.59995H4.80078V7.19995H7.20078V9.59995Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_19_11068">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
